import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { ClarificationRequestDescriptor } from './model/clarification.request';

@Injectable()
export class ClarificationRequestService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig,
  ) {
    super(
      'v1',
      'ClarificationRequestManagement',
      authService,
      config.CMSConfig
    );
  }

  public create(request: ClarificationRequestDescriptor): Promise<string> {
    return super.post<string>(
      new ClarificationRequestDescriptor({
        id: undefined,
        href: undefined,
        dataEntryId: request.dataEntryId,
        organizationId: undefined,
        formId: undefined,
        submittedBy: undefined,
        submittedOn: undefined,
        clarificationRequestState: request.clarificationRequestState,
        isArguable: request.isArguable,
        modified: undefined,
        deleted: undefined
      }));
  }

  public getClarificationRequests(view?: View): Promise<List<ClarificationRequestDescriptor>> {
    return super.get<List<ClarificationRequestDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getById(id: string): Promise<ClarificationRequestDescriptor> {
    return super.get<ClarificationRequestDescriptor>(id);
  }

  public update(id: string, role: ClarificationRequestDescriptor): Promise<ClarificationRequestDescriptor> {
    return super.put<ClarificationRequestDescriptor>(id, role);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/clarification.request/clarification.request.service.ts